import angular from 'angular';
import moment from 'moment';
import 'moment-pl';
import AmCharts from 'amcharts';

/**
 * @ngdoc overview
 * @name commonModule.commonServices
 * @description
 * # commonModule.commonServices
 * Module for managing the common services.
 */
const commonServices = angular.module('commonModule.commonServices', []);

/**
 * @ngdoc interface
 * @name commonModule.commonServices.interface:AppsoupAPI
 * @description
 * Service containing common methods in the whole Appsoup API.
 */
commonServices.factory('AppsoupAPI', ['$translate', 'DATE_FORMAT', function ($translate, DATE_FORMAT) {
    'use strict';
    return {
        // Appsoup API URL prefix
        API_URL: '/api',
        // Table properties
        getSort: function (sortingParams) {
            var sortKey;
            for (var i in sortingParams) {
                if (sortingParams.hasOwnProperty(i)) {
                    sortKey = i;
                }
            }

            return sortKey;
        },
        getTableParams: function (params) {
            if (angular.isDefined(params)) {
                var sortParams = {
                    page: params.page,
                    per_page: params.count
                };

                if (angular.isDefined(params.sorting)) {
                    var sortKey = this.getSort(params.sorting);
                    if (sortKey && params.sorting[sortKey]) {
                        sortParams["sort[]"] = [sortKey, params.sorting[sortKey]];
                    }
                }
                if (angular.isDefined(params.filter)) {
                    if (angular.isDefined(params.filter.name)) {
                        sortParams.name = params.filter.name;
                    }
                }
                if (angular.isDefined(params.login) && angular.isDefinedNotEmpty(params.login)) {
                    sortParams.login = params.login;
                }
                if (angular.isDefined(params.email_or_login) && angular.isDefinedNotEmpty(params.email_or_login)) {
                    sortParams.email_or_login = params.email_or_login;
                }
                if (angular.isDefined(params.app_id) && angular.isDefinedNotEmpty(params.app_id)) {
                    sortParams.app_id = params.app_id;
                }
                if (angular.isDefined(params.title) && angular.isDefinedNotEmpty(params.title)) {
                    sortParams.title = params.title;
                }
                if (angular.isDefined(params.contents) && angular.isDefinedNotEmpty(params.contents)) {
                    sortParams.contents = params.contents;
                }
                if (angular.isDefined(params.street) && angular.isDefinedNotEmpty(params.street)) {
                    sortParams.street = params.street;
                }
                if (angular.isDefined(params.city) && angular.isDefinedNotEmpty(params.city)) {
                    sortParams.city = params.city;
                }
                if (angular.isDefined(params.post_code) && angular.isDefinedNotEmpty(params.post_code)) {
                    sortParams.post_code = params.post_code;
                }
                if (angular.isDefined(params.name) && angular.isDefinedNotEmpty(params.name)) {
                    sortParams.name = params.name;
                }
                if (angular.isDefined(params.category) && angular.isDefinedNotEmpty(params.category)) {
                    sortParams.category = params.category;
                }
                if (angular.isDefined(params.price_from) && angular.isDefinedNotEmpty(params.price_from)) {
                    sortParams.price_from = params.price_from;
                }
                if (angular.isDefined(params.price_to) && angular.isDefinedNotEmpty(params.price_to)) {
                    sortParams.price_to = params.price_to;
                }
                if (angular.isDefined(params.retail_from) && angular.isDefinedNotEmpty(params.retail_from)) {
                    sortParams.retail_from = params.retail_from;
                }
                if (angular.isDefined(params.retail_to) && angular.isDefinedNotEmpty(params.retail_to)) {
                    sortParams.retail_to = params.retail_to;
                }
                if (angular.isDefined(params.user_id) && angular.isDefinedNotEmpty(params.user_id)) {
                    sortParams.user_id = params.user_id;
                }
                if (angular.isDefined(params.beacon_id) && angular.isDefinedNotEmpty(params.beacon_id)) {
                    sortParams.beacon_id = params.beacon_id;
                }
                if (angular.isDefined(params.type) && angular.isDefinedNotEmpty(params.type)) {
                    sortParams.type = params.type;
                }
                if (angular.isDefined(params.created_at) && angular.isDefinedNotEmpty(params.created_at)) {
                    sortParams.created_at = params.created_at;
                }
                if (angular.isDefined(params.updated_at) && angular.isDefinedNotEmpty(params.updated_at)) {
                    sortParams.updated_at = params.updated_at;
                }
                if (angular.isDefined(params.deleted_at) && angular.isDefinedNotEmpty(params.deleted_at)) {
                    sortParams.deleted_at = params.deleted_at;
                }
                if (angular.isDefined(params.beacons) && angular.isDefinedNotEmpty(params.beacons)) {
                    var beaconParam = {
                        "beacons[]": params.beacons
                    };
                    angular.extend(sortParams, beaconParam);
                }
                if (angular.isDefined(params.public) && angular.isDefinedNotEmpty(params.public)) {
                    if (params.public) {
                        sortParams.public = params.public;
                    }
                }
                if (angular.isDefined(params.tags) && angular.isDefinedNotEmpty(params.tags)) {
                    sortParams.tags = params.tags;
                }
                if (angular.isDefined(params.from_date) && angular.isDefinedNotEmpty(params.from_date)) {
                    sortParams.from_date = params.from_date;
                }
                if (angular.isDefined(params.to_date) && angular.isDefinedNotEmpty(params.to_date)) {
                    sortParams.to_date = params.to_date;
                }
                if (angular.isDefined(params.promotions) && angular.isDefinedNotEmpty(params.promotions)) {
                    sortParams.promotions = params.promotions;
                }
                if (angular.isDefined(params.categories) && angular.isDefinedNotEmpty(params.categories)) {
                    sortParams.categories = params.categories;
                }
                if (angular.isDefined(params.sap_id) && angular.isDefinedNotEmpty(params.sap_id)) {
                    sortParams.sap_id = params.sap_id;
                }
                if (angular.isDefined(params.last_login) && angular.isDefinedNotEmpty(params.last_login)) {
                    sortParams.last_login = params.last_login;
                }
                if (angular.isDefined(params.status) && angular.isDefinedNotEmpty(params.status)) {
                    sortParams.status = params.status;
                }
                if (angular.isDefined(params.system) && angular.isDefinedNotEmpty(params.system)) {
                    sortParams.system = params.system;
                }
                if (angular.isDefined(params.placement) && angular.isDefinedNotEmpty(params.placement)) {
                    sortParams.placement = params.placement;
                }
                if (angular.isDefined(params.external_id) && angular.isDefinedNotEmpty(params.external_id)) {
                    sortParams.external_id = params.external_id;
                }
                if (angular.isDefined(params.slug) && angular.isDefinedNotEmpty(params.slug)) {
                    sortParams.slug = params.slug;
                }
                if (angular.isDefined(params.first_name) && angular.isDefinedNotEmpty(params.first_name)) {
                    sortParams.first_name = params.first_name;
                }
                if (angular.isDefined(params.last_name) && angular.isDefinedNotEmpty(params.last_name)) {
                    sortParams.last_name = params.last_name;
                }
                if (angular.isDefined(params.id) && angular.isDefinedNotEmpty(params.id)) {
                    sortParams.id = params.id;
                }
                if (angular.isDefined(params.email) && angular.isDefinedNotEmpty(params.email)) {
                    sortParams.email = params.email;
                }
                if (angular.isDefined(params.hash) && angular.isDefinedNotEmpty(params.hash)) {
                    sortParams.hash = params.hash;
                }
                if (angular.isDefined(params.user_id) && angular.isDefinedNotEmpty(params.user_id)) {
                    sortParams.user_id = params.user_id;
                }
                if (angular.isDefined(params.integration_name) && angular.isDefinedNotEmpty(params.integration_name)) {
                    sortParams.integration_name = params.integration_name;
                }
                if (angular.isDefined(params.display_name) && angular.isDefinedNotEmpty(params.display_name)) {
                    sortParams.display_name = params.display_name;
                }
                if (angular.isDefined(params.start_date) && angular.isDefinedNotEmpty(params.start_date)) {
                    sortParams.start_date = params.start_date;
                }
                if (angular.isDefined(params.end_date) && angular.isDefinedNotEmpty(params.end_date)) {
                    sortParams.end_date = params.end_date;
                }
                if (angular.isDefined(params.group) && angular.isDefinedNotEmpty(params.group)) {
                    sortParams.group = params.group;
                }
                if (angular.isDefined(params.ingredient_category_id) && angular.isDefinedNotEmpty(params.ingredient_category_id)) {
                    sortParams.ingredient_category_id = params.ingredient_category_id;
                }
                if (angular.isDefined(params.new_integration_name) && angular.isDefinedNotEmpty(params.new_integration_name)) {
                    sortParams.new_integration_name = params.new_integration_name;
                }
                if (angular.isDefined(params.new_integration_category) && angular.isDefinedNotEmpty(params.new_integration_category)) {
                    sortParams.new_integration_category = params.new_integration_category;
                }
                if (angular.isDefined(params.integration_attributes) && angular.isDefinedNotEmpty(params.integration_attributes)) {
                    sortParams.integration_attributes = params.integration_attributes;
                }
                if (angular.isDefined(params.news_date) && angular.isDefinedNotEmpty(params.news_date)) {
                    sortParams.news_date = params.news_date;
                }
                if (angular.isDefined(params.status_label) && angular.isDefinedNotEmpty(params.status_label)) {
                    sortParams.status_label = params.status_label;
                }
                if (angular.isDefined(params.type_coupon) && angular.isDefinedNotEmpty(params.type_coupon)) {
                    sortParams.type_coupon = params.type_coupon;
                }
                if (angular.isDefined(params.type_coupon_delikatesy) && angular.isDefinedNotEmpty(params.type_coupon_delikatesy)) {
                    sortParams.type_coupon_delikatesy = params.type_coupon_delikatesy;
                }
                if (angular.isDefined(params.type_coupon_ids) && angular.isDefinedNotEmpty(params.type_coupon_ids)) {
                    var typeCouponParam = {
                        "type_coupon_ids[]": params.type_coupon_ids
                    };
                    angular.extend(sortParams, typeCouponParam);
                }
                if (angular.isDefined(params.type_product) && angular.isDefinedNotEmpty(params.type_product)) {
                    sortParams.type_product = params.type_product;
                }
                if (angular.isDefined(params.type_product_ids) && angular.isDefinedNotEmpty(params.type_product_ids)) {
                    var typeProductParam = {
                        "type_product_ids[]": params.type_product_ids
                    };
                    angular.extend(sortParams, typeProductParam);
                }

                return sortParams;
            } else {
                return {};
            }
        },
        getDefaultTableParams: function () {
            return {
                page: 1, // show first page
                count: 100, // count per page
                sorting: {
                    name: 'asc'     // initial sorting
                }
            };
        },
        getPublicTableParams: function () {
            return {
                page: 1, // show first page
                count: 100, // count per page
                public: true,
                sorting: {
                    name: 'asc'     // initial sorting
                }
            };
        },
        getUserTableParams: function () {
            return {
                page: 1, // show first page
                count: 100, // count per page
                sorting: {
                    user_id: 'asc'     // initial sorting
                }
            };
        },
        getEmailTableParams: function () {
            return {
                page: 1, // show first page
                count: 100, // count per page
                sorting: {
                    email: 'asc'     // initial sorting
                }
            };
        },
        getStatusTableParams: function () {
            return {
                page: 1, // show first page
                count: 100, // count per page
                sorting: {
                    status: 'desc'     // initial sorting
                }
            };
        },
        getRatiNgTableParams: function () {
            return {
                page: 1, // show first page
                count: 100, // count per page
                sorting: {
                    rating: 'asc'     // initial sorting
                }
            };
        },
        getTitleTableParams: function () {
            return {
                page: 1, // show first page
                count: 100, // count per page
                sorting: {
                    title: 'asc'     // initial sorting
                }
            };
        },
        getDateTableParams: function () {
            return {
                page: 1, // show first page
                count: 100, // count per page
                sorting: {
                    date: 'asc'     // initial sorting
                }
            };
        },
        getOrderTableParams: function () {
            return {
                page: 1, // show first page
                count: 100, // count per page
                sorting: {
                    order: 'asc'     // initial sorting
                }
            };
        },
        getByOrderTableParams: function () {
            return {
                page: 1, // show first page
                count: 10, // count per page
                sorting: {
                    order: 'asc'     // initial sorting
                }
            };
        },
        getByOrderDescTableParams: function () {
            return {
                page: 1, // show first page
                count: 100, // count per page
                sorting: {
                    order: 'desc'     // initial sorting
                }
            };
        },
        getIdTableParams: function () {
            return {
                page: 1, // show first page
                count: 100, // count per page
                sorting: {
                    id: 'desc'     // initial sorting
                }
            };
        },
        getIdAscTableParams: function () {
            return {
                page: 1, // show first page
                count: 100, // count per page
                sorting: {
                    id: 'asc'     // initial sorting
                }
            };
        },
        getExternalIdTableParams: function () {
            return {
                page: 1, // show first page
                count: 100, // count per page
                sorting: {
                    external_id: 'asc'     // initial sorting
                }
            };
        },
        getCreatedAtTableParams: function () {
            return {
                page: 1, // show first page
                count: 100, // count per page
                sorting: {
                    created_at: 'desc'     // initial sorting
                }
            };
        },
        getDefaultCounts: function () {
            return [
                100,
                200,
                500,
                1000
            ];
        },
        getMinDefaultstCounts: function () {
            return [
                10,
                20,
                50,
                100
            ];
        },
        preparePlacesTree: function (selected) {
            var places = {place: [], place_level: [], area: [], zone: [], beacon: []};

            if (angular.isDefinedNotNull(selected)) {
                places = {
                    place: selected.places || [],
                    place_level: selected.levels || [],
                    area: selected.areas || [],
                    zone: selected.zones || [],
                    beacon: selected.beacons || []
                };
            }

            return places;
        },
        convertPlacesTree: function (selected) {
            if (angular.isNullOrUndefined(selected)) {
                selected = {};
            }

            return {
                places: selected.place || [],
                levels: selected.place_level || [],
                areas: selected.area || [],
                zones: selected.zone || [],
                beacons: selected.beacon || []
            };
        },
        getPickerRanges: function () {
            var ranges = {};

            ranges[$translate.instant('RANGES.TODAY')] = [moment(), moment()];
            ranges[$translate.instant('RANGES.YESTERDAY')] = [moment().subtract(1, 'days'), moment().subtract(1, 'days')];
            ranges[$translate.instant('RANGES.LAST_7')] = [moment().subtract(6, 'days'), moment()];
            ranges[$translate.instant('RANGES.LAST_30')] = [moment().subtract(29, 'days'), moment()];
            ranges[$translate.instant('RANGES.THIS_MONTH')] = [moment().startOf('month'), moment().endOf('month')];
            ranges[$translate.instant('RANGES.PREV_MONTH')] = [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')];

            return {
                ranges: ranges,
                format: DATE_FORMAT.SHORT,
                locale: {
                    fromLabel: $translate.instant('DATE.DATE_FROM'),
                    toLabel: $translate.instant('DATE.DATE_TO'),
                    customRangeLabel: $translate.instant('DATE.CUSTOM_RANGE'),
                    applyLabel: $translate.instant('APPLY'),
                    cancelLabel: $translate.instant('CANCEL')
                }
            };
        },
        getDefaultDateRange: function () {
            return {startDate: moment().subtract(29, 'days'), endDate: moment()};
        },
        getDateRange: function (start, end) {
            return {startDate: moment(start), endDate: moment(end)};
        },
        calculateMode: function (permission) {
            var mode = 0;
            if (angular.isDefined(permission.read) && permission.read) {
                mode = 1;
            }
            if (angular.isDefined(permission.write) && permission.write) {
                mode = mode + 2;
            }

            return mode;
        },
        modeToObject: function (mode) {
            var permission = {};
            if (mode === 1 || mode === 3) {
                permission.read = true;
            }
            if (mode >= 2) {
                permission.write = true;
            }

            return permission;
        }
    };
}]);

/**
 * @ngdoc interface
 * @name commonModule.commonServices.interface:AppsoupHttpInterceptor
 * @description
 * Http interceptor for all Appsoup $http calls
 */
commonServices.factory('AppsoupHttpInterceptor', ['$rootScope', '$q', 'growl', function ($rootScope, $q, growl) {
    'use strict';
    return {
        'requestError': function (rejection) {
            return $q.reject(rejection);
        },
        'responseError': function (rejection) {
            if (angular.isDefined(rejection.status)) {
                var errorMsg = '';
                switch (rejection.status) {
                    case 400:
                        errorMsg = 'ERROR.HTTP.400';
                        break;
                    case 401:
                        errorMsg = 'ERROR.HTTP.401';
                        $rootScope.$broadcast('userNotLoggedIn');
                        break;
                    case 403:
                        errorMsg = 'ERROR.HTTP.403';
                        $rootScope.$broadcast('userNotLoggedIn');
                        break;
                    case 404:
                        // errorMsg = 'ERROR.HTTP.404';
                        $rootScope.$broadcast('404');
                        break;
                    case 413:
                        errorMsg = 'ERROR.HTTP.413';
                        break;
                    case 500:
                        errorMsg = 'ERROR.HTTP.500';
                        break;
                    case 504:
                        errorMsg = 'ERROR.HTTP.504';
                        break;
                    default:
                        /* eslint-disable-next-line */
                        console.error('ERROR not handled yet!', rejection);
                }
                if (errorMsg !== '') {
                    growl.error(errorMsg);
                }
            }

            return $q.reject(rejection);
        }
    };
}]);

/**
 * @ngdoc interface
 * @name commonModule.commonServices.interface:showErrorsConfig
 * @description
 * Config provider for showErrors directive
 */
commonServices.provider('showErrorsConfig', function () {
    'use strict';
    var _showSuccess;
    _showSuccess = false;
    this.showSuccess = function (showSuccess) {
        return _showSuccess = showSuccess;
    };
    this.$get = function () {
        return {showSuccess: _showSuccess};
    };
});

/**
 * @ngdoc interface
 * @name commonModule.commonServices.interface:LanguageService
 * @description
 * Service for handling the Language of the interface
 */
commonServices.service('LanguageService', ['$q', '$translate', function ($q, $translate) {
    'use strict';
    var getLangKey = function (lang) {
        switch (parseInt(lang)) {
            case 1:
                return 'pl';
            case 2:
            default:
                return 'en';
        }
    };

    this.changeTo = function (newLang) {
        var defer = $q.defer();

        if (angular.isDefined(newLang)) {
            var lang = getLangKey(newLang);
            $translate.use(lang);
            defer.resolve('Language successfully changed.');
        } else {
            defer.reject('Could not change the language!');
        }

        return defer.promise;
    };
}]);

/**
 * @ngdoc interface
 * @name commonModule.commonServices.interface:ChartService
 * @description
 * Service for handling Charts (drawing, handlers, options)
 */
commonServices.service('ChartService', ['$translate', '$timeout', function ($translate, $timeout) {
    'use strict';

    var COLOR = {
        'MAIN': '#1e2045',
        'MAIN_LIGHT': '#8a8b9e',
        'SECONDARY': '#23b32d',
        'AXIS': '#cbcbd3',
        'FILL': '#cbcbd3',
        'VAR1': '#a0a0b4',
        'VAR2': '#a864a8',
        'VAR3': '#74c9e9',
        'VAR4': '#63c3e7',
        'VAR5': '#e9a074',
        'VAR6': '#444664',
        'VAR7': '#1d6b4d',
        'VAR8': '#52febb'
    };

    var serialChartOptions = {
        type: 'serial',
        pathToImages: '/assets/amcharts/',
        categoryField: 'date',
        fontSize: 13,
        fontFamily: 'inherit',
        categoryAxis: {
            axisThickness: 0,
            gridThickness: 0
        },
        valueAxes: [
            {
                labelFrequency: 2,
                axisColor: COLOR.AXIS,
                axisAlpha: 0.5,
                axisThickness: 0,
                tickLength: 0
            }
        ],
        responsive: {
            enabled: true
        },
        zoomOutButtonImage: 'reset.png',
        zoomOutButtonAlpha: 0.8,
        zoomOutButtonColor: COLOR.FILL,
        zoomOutButtonRollOverAlpha: 1,
        zoomOutText: $translate.instant('CHARTS.RESET')
    };

    var pieChartOptions = {
        type: 'pie',
        balloonText: '[[title]]<br><span style="font-size:14px"><b>[[value]]</b> ([[percents]]%)</span>',
        innerRadius: '75%',
        pullOutDuration: 0,
        startDuration: 0,
        titleField: 'title',
        valueField: 'value',
        hoverAlpha: 0.75,
        fontSize: 12,
        pullOutRadius: '0%',
        fontFamily: 'inherit',
        color: COLOR.MAIN,
        labelsEnabled: false,
        allLabels: [],
        balloon: {},
        outlineThickness: 0,
        legend: {
            align: 'center',
            maxColumns: 2,
            useMarkerColorForValues: true,
            markerType: 'circle',
            valueText: '[[description]] [[value]]'
        },
        responsive: {
            enabled: true
        },
        colors: [
            COLOR.MAIN,
            COLOR.SECONDARY,
            COLOR.VAR1,
            COLOR.VAR2,
            COLOR.VAR3,
            COLOR.VAR4,
            COLOR.VAR5,
            COLOR.VAR6,
            COLOR.VAR7,
            COLOR.VAR8,
            COLOR.AXIS
        ]
    };

    var createChart = function (defaultOptions, chartId, options) {
        var chartData = angular.copy(defaultOptions);
        angular.extend(chartData, options);
        if (angular.isDefined(chartData.legend)) {
            chartData.legend.divId = 'legend-' + chartId;
        }
        var jsonstring = angular.toJson(chartData); // Hack
        var chart = AmCharts.makeChart(chartId, angular.fromJson(jsonstring));
        //chart.invalidateSize();

        return chart;
    };

    this.createSerialChart = function (chartId, options) {
        return createChart(serialChartOptions, chartId, options);
    };

    this.createPieChart = function (chartId, options) {
        return createChart(pieChartOptions, chartId, options);
    };

    this.addHoverState = function (chart) {
        // Hover active
        var preventInfinite = false;
        chart.addListener('changed', function (e) {
            for (var i = 0; i < chart.dataProvider.length; i++) {
                chart.dataProvider[i].columnColor = i == e.index ? COLOR.SECONDARY : COLOR.MAIN;
                chart.dataProvider[i].lineColor = i == e.index ? 'white' : '';
            }
            if (!preventInfinite) {
                preventInfinite = true;
                chart.validateData();
                $timeout(function () {
                    preventInfinite = false;
                }, 40);
            }
        });

        // Hover inactive
        chart.addListener('rollOutGraph', function () {
            for (var i = 0; i < chart.dataProvider.length; i++) {
                chart.dataProvider[i].columnColor = COLOR.MAIN;
                chart.dataProvider[i].lineColor = '';
            }
            chart.validateData();
        });
    };

    this.generateTotalLabels = function (data) {
        return [
            {
                text: $translate.instant('CHARTS.TOTAL'),
                align: 'center',
                bold: false,
                y: 70
            },
            {
                text: data,
                align: 'center',
                size: 30,
                bold: true,
                y: 90
            }
        ];
    };

    this.generateChartScrollbar = function (graph) {
        return {
            graph: graph,
            autoGridCount: true,
            scrollbarHeight: 30,
            markPeriodChange: true,
            backgroundAlpha: 0,
            color: COLOR.MAIN_LIGHT,
            graphFillColor: COLOR.FILL,
            selectedBackgroundColor: COLOR.FILL,
            selectedGraphFillAlpha: 0.5,
            selectedGraphFillColor: COLOR.VAR1
        };
    };

    this.generateCategoryAxis = function () {
        return {
            minPeriod: 'hh',
            parseDates: true,
            equalSpacing: true
        };
    };

    this.getSerialChartGraph = function (id, valueField) {
        return {
            id: id,
            type: 'smoothedLine',
            valueField: valueField,
            balloonText: '[[value]]',
            bullet: 'round',
            lineColor: COLOR.MAIN,
            lineThickness: 3,
            fillColors: COLOR.MAIN,
            fillAlphas: 0.55
        };
    };

    this.generateChartHourData = function (chartData, interval) {
        var serialChartData = [];

        angular.forEach(chartData, function (data, key) {
            var chartData = 0, counter = 1, intervalKey = '';
            switch (interval) {
                case 1:
                    angular.forEach(data, function (hourData, hour) {
                        var i = parseInt(hour);
                        serialChartData.push({
                            date: key + " " + i + ":00",
                            value: hourData
                        });
                    });
                    break;

                case 2:
                case 4:
                case 6:
                case 8:
                case 12:
                    chartData = 0;
                    counter = 1;
                    intervalKey = '';
                    angular.forEach(data, function (hourData, hour) {
                        var i = parseInt(hour);
                        chartData = chartData + hourData;
                        if (counter === 1) {
                            intervalKey = key + " " + i + ":00";
                        } else if (counter === interval) {
                            serialChartData.push({
                                date: intervalKey,
                                value: chartData
                            });
                            counter = 0;
                            chartData = 0;
                        }
                        counter++;
                    });
                    break;

                case 24:
                default:
                    chartData = 0;
                    angular.forEach(data, function (hourData) {
                        chartData = chartData + hourData;
                    });
                    serialChartData.push({
                        date: key,
                        value: chartData
                    });
                    break;
            }
        });

        return serialChartData;
    };

    this.generateChartScrollbarLabel = function (valueText, date) {
        var format = moment(valueText, [
            'MMM D',
            'MMM',
            'LT'
        ], 'en')._f;

        return moment(date).format(format);
    };

    this.generateCategoryAxisLabel = function (valueText, date, isHourMode) {
        if (isHourMode) {
            var format = moment(valueText, [
                'MMM D',
                'MMM',
                'LT'
            ], 'en')._f;

            return moment(date).format(format);
        } else {
            return moment(date).format('ddd[,] D MMM');
        }
    };

    this.getColors = function () {
        return COLOR;
    };
}]);

/**
 * @ngdoc interface
 * @name commonModule.commonServices.interface:TreeService
 * @description
 * Service for handling common features of trees
 */
commonServices.service('TreeService', ['$translate', function ($translate) {
    'use strict';
    this.getIconToggleClass = function (place) {
        var iconClass = '';
        if (angular.isDefined(place.children) && place.children.length) {
            iconClass = place.showChildren ? 'li-arrow-down' : 'li-arrow-right';
        }

        return iconClass;
    };

    this.getIconClass = function (place) {
        var iconClass = '';
        switch (place.type) {
            case 'place':
                iconClass = 'li-place';
                break;
            case 'level':
            case 'place_level':
                iconClass = 'li-level';
                break;
            case 'area':
                iconClass = 'li-area';
                break;
            case 'zone':
                iconClass = 'li-zone';
                break;
            case 'beacon':
                iconClass = 'fa fa-dot-circle-o';
                break;
        }

        return iconClass;
    };

    this.getPlaceTooltip = function (place) {
        var tooltip = '';
        if (angular.isDefined(place.type)) {
            tooltip = $translate.instant('MODULES.PLACES.TOOLTIP.' + place.type.toUpperCase());
        }

        return tooltip;
    };
}]);

/**
 * @ngdoc interface
 * @name commonModule.commonServices.interface:Session
 * @description
 * Service for handling current user's session
 */
commonServices.service('Session', ['$rootScope', 'DATE_FORMAT', function ($rootScope, DATE_FORMAT) {
    'use strict';
    var dateStart = localStorage.getItem('appsoup:dateStart') || moment().subtract(29, 'days'),
        dateEnd = localStorage.getItem('appsoup:dateEnd') || moment();

    dateStart = moment(dateStart).format(DATE_FORMAT.URL);
    dateEnd = moment(dateEnd).format(DATE_FORMAT.URL);

    this.getDateStateParams = function () {
        return {
            dateStart: dateStart,
            dateEnd: dateEnd
        };
    };

    this.getDateMomentParams = function () {
        return {
            startDate: moment(dateStart),
            endDate: moment(dateEnd)
        };
    };

    this.setDate = function (start, end) {
        dateStart = moment(start).format(DATE_FORMAT.URL);
        dateEnd = moment(end).format(DATE_FORMAT.URL);

        localStorage.setItem('appsoup:dateStart', dateStart);
        localStorage.setItem('appsoup:dateEnd', dateEnd);

        $rootScope.$broadcast('dateChange', this.getDateStateParams());

        return this.getDateStateParams();
    };
}]);

export default commonServices;
